(function () {
  'use strict';

  /* Ninja Gang Sheet Builder CTA — UK
     ---------------------------------
     Keeps the CTA's href in sync with the selected variant on the two gang
     sheet BUILDER pages (DTF and UV). One param, `?variant=<id>`; the builder
     resolves size and transfer type from it.

     ⚠ NO OPTIMIZELY. The US twin pushes `gsb_cta_click` into Optimizely and
     also mirrors that tracking onto the OLD app-block CTA
     ([data-gsb-variant="old"] #gs-builder-btn). Both are removed here: there is
     no Optimizely on the UK storefront (verified 2026-08-19), and the old app
     block no longer exists on these pages at all, so the mirror would bind to
     nothing. Do not re-add either. */

  function init() {
    var wrapper = document.querySelector('.new-gang-sheet-cta-wrapper');
    if (!wrapper) return;
    var button = wrapper.querySelector('[data-gsb-new-cta]');
    var dataScript = wrapper.querySelector('.new-gang-sheet-cta-variants');
    var proxyPath = wrapper.getAttribute('data-gsb-proxy-path') || '/apps/ninja-gang-sheet';
    if (!button || !dataScript) return;

    var variants = [];
    try { variants = JSON.parse(dataScript.textContent) || []; } catch (e) { variants = []; }
    var variantsById = {};
    variants.forEach(function (v) { variantsById[String(v.id)] = v; });

    function updateHref(variant) {
      if (!variant || !variant.id) return;
      button.href = proxyPath + '?variant=' + encodeURIComponent(variant.id);
    }

    /* Only an explicit ?variant= in the page URL overrides the server-seeded
       href. Liquid already seeded it from selected_or_first_available_variant,
       which is the first AVAILABLE variant — re-seeding from variants[0] here
       (as the US file does) would quietly point the CTA at an unavailable
       variant whenever the first one is sold out. */
    try {
      var urlVariant = new URLSearchParams(window.location.search).get('variant');
      if (urlVariant && variantsById[urlVariant]) updateHref(variantsById[urlVariant]);
    } catch (e) { /* noop */ }

    /* VARIANT_CHANGE is dispatched NON-BUBBLING on <product-variants>, so this
       must stay on the capture phase — a bubble-phase listener never sees it. */
    document.addEventListener('VARIANT_CHANGE', function (e) {
      var el = e.target;
      if (el && el.currentVariant) updateHref(el.currentVariant);
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
